export default {
    methods: {
        createSmaStorageListBool: function() {
            this.$store.state.smaStorageListBool = [];
            this.$store.state.smaStorageList.forEach((value) => {
                this.$store.state.smaStorageListBool.push(value);
            });
        },
        createBatteriesListBool() {
            this.$store.state.batteriesListBool = [];
            this.$store.state.batteriesList.forEach((value) => {
                this.$store.state.batteriesListBool.push(value);
            });
        },
        createCablesListBool() {
            this.$store.state.cablesListBool = [];
            this.$store.state.cablesList.forEach((value) => {
                this.$store.state.cablesListBool.push(value);
            });
        },
        createMetersListBool() {
            this.$store.state.metersListBool = [];
            this.$store.state.metersList.forEach((value) => {
                this.$store.state.metersListBool.push(value);
            });
        },
        createModulesListBool() {
            this.$store.state.modulesListBool = [];
            this.$store.state.modulesList.forEach((value) => {
                if(value.FullBlack == "0") {
                    value.FullBlack = false;
                } else {
                    value.FullBlack = true;
                }
                if(value.Bisun == "0") {
                    value.Bisun = false;
                } else {
                    value.Bisun = true;
                }
                if(value.optimizer == "0") {
                    value.optimizer = false;
                } else {
                    value.optimizer = true;
                }
                this.$store.state.modulesListBool.push(value);
            });
        },
        createInvertersListBool() {
            this.$store.state.invertersListBool = [];
            this.$store.state.invertersList.forEach((value) => {
                if(value.EXTENDED == "0") {
                    value.EXTENDED = false;
                } else {
                    value.EXTENDED = true;
                }
                if(value.DELTA_COMPATIBLE == "0") {
                    value.DELTA_COMPATIBLE = false;
                } else {
                    value.DELTA_COMPATIBLE = true;
                }
                if(value.STOREDGE == "0") {
                    value.STOREDGE = false;
                } else {
                    value.STOREDGE = true;
                }
                if(value.EV == "0") {
                    value.EV = false;
                } else {
                    value.EV = true;
                }
                this.$store.state.invertersListBool.push(value);
            });
        },
        createOptimizersListBool() {
            this.$store.state.optimizersListBool = [];
            this.$store.state.optimizersList.forEach((value) => {
                if(value.OPTIMIZATION == "0") {
                    value.OPTIMIZATION = false;
                } else {
                    value.OPTIMIZATION = true;
                }
                if(value.SAFETY == "0") {
                    value.SAFETY = false;
                } else {
                    value.SAFETY = true;
                }
                if(value.MONITORING == "0") {
                    value.MONITORING = false;
                } else {
                    value.MONITORING = true;
                }
                if(value.GATEWAY == "0") {
                    value.GATEWAY = false;
                } else {
                    value.GATEWAY = true;
                }
                if(value.CLOUD_CONNECT == "0") {
                    value.CLOUD_CONNECT = false;
                } else {
                    value.CLOUD_CONNECT = true;
                }
                this.$store.state.optimizersListBool.push(value);
            });
        },
        createUsersListBool() {
            this.$store.state.usersListBool = [];
            this.$store.state.usersList.forEach((value) => {
                if(value.ADMIN == "0") {
                    value.ADMIN = false;
                } else {
                    value.ADMIN = true;
                }
                this.$store.state.usersListBool.push(value);
            });
        },
    }
};
